import { formatClock } from './MentorAvailabilityPanel';
import type { MentorMenteeCard, MentorUpcomingBooking } from './MentorPortalService';
import { formatModeLabel } from './mentee/menteeSessionsFormat';

type Props = {
    bookings: MentorUpcomingBooking[];
    mentees: MentorMenteeCard[];
    isLoading: boolean;
    loadError: string | null;
};

const menteeNameForPair = (
    pairId: number | null | undefined,
    mentees: MentorMenteeCard[]
): string => {
    if (pairId == null) return '—';
    const match = mentees.find((row) => row.pairId === pairId);
    return match?.menteeName || '—';
};

const renderJoin = (link: string | null | undefined) => {
    const trimmed = (link || '').trim();
    if (!trimmed) {
        return <span className="msess-muted">No link provided</span>;
    }
    return (
        <a href={trimmed} target="_blank" rel="noopener noreferrer" className="btn-green btn-sm rounded-pill px-4 py-2 h-auto">
            <span>Join</span>
        </a>
    );
};

const MentorUpcomingBookings = ({ bookings, mentees, isLoading, loadError }: Props) => {
    if (loadError) {
        return <p className="msess-empty">{loadError}</p>;
    }
    if (isLoading) {
        return <p className="msess-empty">Loading upcoming bookings…</p>;
    }
    if (bookings.length === 0) {
        return (
            <div className="msess-empty-card">
                <p className="msess-empty">No upcoming bookings yet.</p>
            </div>
        );
    }

    return (
        <div className="msess-list-card">
            <p className="msess-tz">Times are shown as Asia/Kolkata (IST).</p>
            <div className="row g-3">
                {bookings.map((row) => (
                    <div key={row.id} className="col-lg-4 col-md-6 col-sm-6">
                        <div className="bg-success bg-opacity-10 border border-success border-opacity-25 rounded-3 p-3 font-13 text-black lh-base">
                            <div className="msess-upcoming-main">
                            <p className="msess-upcoming-when">
                                {row.bookedDate || '—'} ·{' '}
                                {formatClock(Number(row.startMinute || 0))}
                                {row.durationMinutes != null ? ` · ${row.durationMinutes} min` : ''}
                            </p>
                            <div className="font-16 font-600 text-black d-flex align-items-center gap-1">
                                <span className="font-16 font-600 text-black">{menteeNameForPair(row.pairId, mentees)}</span> 
                                <span className="badge bg-white text-dark rounded-pill mx-2 font-12 font-500 py-2 px-3 shadow-sm" >
                                    {formatModeLabel(row.mode)}
                                </span>
                            </div>
                            <p className="font-14 font-weight-500 text-dark mb-0">{row.topic || '—'}</p>
                            {row.agenda ? (
                                <p className="font-14  text-dark mb-0">
                                    <strong className='font-weight-500'>Agenda:</strong> {row.agenda}
                                </p>
                            ) : null}

                            <div className="d-flex gap-2">{renderJoin(row.sessionLink)}</div>
                        </div>
                        
                        </div>
                        
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MentorUpcomingBookings;
